function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryDiscount = function SvgDeliveryDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2389_1479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.92 43.1022H60.6486C57.3377 43.1022 54.6537 45.7853 54.6537 49.0952V91.3535C54.6537 94.6633 57.3377 97.3465 60.6486 97.3465H102.92C106.23 97.3465 108.914 94.6633 108.914 91.3535V49.0952C108.914 45.7853 106.23 43.1022 102.92 43.1022Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 98H60.6486C56.9811 98 54 95.0198 54 91.3534V49.0952C54 45.4288 56.9811 42.4486 60.6486 42.4486H102.92C106.587 42.4486 109.568 45.4288 109.568 49.0952V91.3534C109.568 95.0198 106.587 98 102.92 98ZM60.6486 43.7557C57.7067 43.7557 55.3075 46.1542 55.3075 49.0952V91.3534C55.3075 94.2944 57.7067 96.6929 60.6486 96.6929H102.92C105.861 96.6929 108.261 94.2944 108.261 91.3534V49.0952C108.261 46.1542 105.861 43.7557 102.92 43.7557H60.6486Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.803 37.2202H66.5322C63.2214 37.2202 60.5374 39.9034 60.5374 43.2132V85.4715C60.5374 88.7813 63.2214 91.4645 66.5322 91.4645H108.803C112.114 91.4645 114.798 88.7813 114.798 85.4715V43.2132C114.798 39.9034 112.114 37.2202 108.803 37.2202Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.803 92.118H66.5322C62.8647 92.118 59.8837 89.1379 59.8837 85.4715V43.2132C59.8837 39.5468 62.8647 36.5667 66.5322 36.5667H108.803C112.471 36.5667 115.452 39.5468 115.452 43.2132V85.4715C115.452 89.1379 112.471 92.118 108.803 92.118ZM66.5322 37.8737C63.5904 37.8737 61.1912 40.2723 61.1912 43.2132V85.4715C61.1912 88.4124 63.5904 90.8109 66.5322 90.8109H108.803C111.745 90.8109 114.144 88.4124 114.144 85.4715V43.2132C114.144 40.2723 111.745 37.8737 108.803 37.8737H66.5322Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.687 31.3384H72.4159C69.1051 31.3384 66.4211 34.0215 66.4211 37.3314V79.5897C66.4211 82.8995 69.1051 85.5827 72.4159 85.5827H114.687C117.998 85.5827 120.682 82.8995 120.682 79.5897V37.3314C120.682 34.0215 117.998 31.3384 114.687 31.3384Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.626 41.7951H134.319C134.319 28.502 123.499 17.6793 110.196 17.6793V16.3722C124.218 16.3722 135.626 27.7766 135.626 41.7951Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 36.4229H139.693C139.693 23.1298 128.873 12.3071 115.569 12.3071V11C129.592 11 141 22.4044 141 36.4229Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4583 62.2249C86.4583 57.1665 86.4583 52.1015 86.4714 47.0431C86.4714 46.762 86.4714 46.4876 86.4844 46.2065C86.5171 45.1216 87.3343 44.7426 88.0338 44.5857C89.982 44.1479 91.9367 43.7427 93.8913 43.344C96.271 42.8604 98.6506 42.4094 101.03 41.9193C102.802 41.5533 104.567 41.1481 106.345 40.7886C106.973 40.6579 107.607 40.6122 108.215 40.9847C108.764 41.318 108.94 41.8147 108.993 42.3833C109.052 42.9519 109.071 43.5205 109.071 44.089C109.071 51.0297 109.097 57.9769 109.065 64.9175C109.052 67.2442 108.195 69.2636 106.43 70.8321C105.41 71.7406 104.207 72.3288 102.854 72.5444C100.618 72.8973 98.5787 72.4595 96.794 70.9955C95.4211 69.8714 94.5124 68.4728 94.1463 66.7475C93.6821 64.545 94.0679 62.4864 95.4211 60.663C96.5782 59.1075 98.1341 58.1141 100.043 57.7481C101.481 57.4737 102.913 57.5782 104.286 58.1533C104.6 58.2841 104.913 58.4017 105.266 58.5455V44.8602C100.252 45.8928 95.2511 46.9254 90.2173 47.9646C90.2173 48.141 90.2173 48.3175 90.2173 48.4874C90.2173 55.1928 90.2173 61.9047 90.2173 68.6101C90.2173 71.0609 89.3021 73.1261 87.4258 74.7207C86.7067 75.3351 85.8699 75.7468 84.9612 76.054C83.0458 76.6944 81.163 76.5833 79.3979 75.6945C77.1752 74.5769 75.7369 72.7666 75.2532 70.2701C74.8217 68.0219 75.3381 66.009 76.7437 64.2248C77.9335 62.7086 79.4959 61.7936 81.4114 61.506C83.0327 61.2642 84.5951 61.4145 86.0661 62.1923C86.1576 62.2445 86.2753 62.2511 86.3864 62.2772C86.4125 62.2511 86.4322 62.2315 86.4583 62.2053V62.2249ZM101.488 61.4341C99.3828 61.2773 97.6961 63.0484 97.7223 65.1332C97.7419 67.2442 99.2782 68.8846 101.416 68.9172C103.652 68.9499 105.247 67.2572 105.286 65.1005C105.319 63.153 103.612 61.2642 101.494 61.4341H101.488ZM82.647 72.6425C84.8632 72.7274 86.321 70.7864 86.4125 69.1656C86.5564 66.6887 84.5821 65.1594 82.7189 65.1332C80.5354 65.1071 78.9664 66.8063 78.8814 68.8127C78.7964 70.8321 80.8361 72.8647 82.647 72.6425Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8447 60.8851C89.8447 60.8851 89.8186 60.9113 89.799 60.9309C89.812 60.9178 89.8251 60.9047 89.8447 60.8851Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2389_1479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(54 11)"
  }))));
};
export default SvgDeliveryDiscount;